import React, { useState, useEffect } from 'react';
import TablaAvanceUnDia from './TablaAvanceUnDia';
import RegistroActividadEjecutada from './RegistroActividadEjecutada';

const TablaAvanceDiarioActividad = (p) => {
    const historial = p.historial ?? false; //determina si se esta en modo hisorial para no permitir el registro de actividades
    const data = p.data;
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const [agregar, setagregar] = useState(null);
    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();


    const agregarActividad = (dia, dia_numero) => {
        if ((dia_numero > currentDayOfWeek && currentDayOfWeek !== 0) || agregar || historial) return;

        setagregar({ data: data, dia: dia, dia_numero: dia_numero });
    }

    const cerrarRegistro = () => setagregar(null);

    return (
        <div className='w-100 p-2 round-l'>
            <table className='table table-sm'>
                <thead>
                    <tr>
                        {
                            dias.map((dia, index) => <th key={index + dia} className='capitalize text-s bg-dark text-white border border-secondary'>{dia}</th>)
                        }
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {dias.map((dia, index) =>
                            <th key={index + dia}
                                className={`m-0 p-0 border-none 
                                    ${!historial && agregar && agregar.dia_numero !== (index + 1) ? 'opacity-30' : ''}
                                    ${!historial && !agregar && currentDayOfWeek === (index + 1) ? 'scale-continue-025 pointer' : ''} 
                                    ${!historial && !agregar && (currentDayOfWeek > (index + 1) || currentDayOfWeek == 0) ? 'pointer scale-025' : ''}`}
                                onClick={() => agregarActividad(dia, (index + 1))}>
                                <TablaAvanceUnDia plan={data[(dia + "_plan")]} ejecutado={data[(dia + "_ejecutado")]} uh={data.unidad_hora} dia={(index + 1) <= currentDayOfWeek} />
                            </th>)}
                    </tr>
                </tbody>
            </table>
            {agregar && <RegistroActividadEjecutada data={agregar} setagregar={setagregar} close={cerrarRegistro} registrar={p.registrar} cerrarPadre={p.cerrarPadre} />}
        </div>
    )
}

export default TablaAvanceDiarioActividad;